<template>
  <div v-if="!loader" class="orientation column label wrap">
    <div class="row wrap">
      <div class="grid-6-s grid-3">
        <label>Cliente</label><br />
        <strong>{{ modal.job.nome_cliente }}</strong>
      </div>
      <div class="grid-6-s grid-5">
        <label>Atendimento</label><br />
        <strong>{{ modal.job.forma_atendimento }}</strong>
      </div>
      <div class="grid-6-s grid-4">
        <label>Status</label> <br />
        <strong>{{ modal.job.status }}</strong>
      </div>
    </div>
    <div class="grid-12" v-if="content.orientacao">
      <label>Orientações</label> <br />
      <strong>{{ content.orientacao }}</strong>
    </div>
    <div class="grid-12" v-if="content.orientacao_presencial && modal.job.forma_atendimento == 'presencial'">
      <label>Orientações</label> <br />
      <strong>{{ content.orientacao_presencial }}</strong>
    </div>
    <div class="grid-12" v-if="content.orientacao_remoto && modal.job.forma_atendimento == 'remoto'">
      <label> Orientações</label> <br />
      <strong>{{ content.orientacao_remoto }}</strong>
    </div>
    <div class="grid-12" v-if="modal.job.forma_atendimento == 'presencial'">
      <label>Requerimentos</label> <br />
      <strong>{{ content.requerimento || content.requerimento_presencial }}</strong>
    </div>
    <div class="grid-12" v-else>
      <label>Requerimentos</label> <br />
      <strong>{{ content.requerimento || content.requerimento_remoto }}</strong>
    </div>
    <div class="grid-12" v-if="modal.job.forma_atendimento == 'presencial'">
      <label>RAT</label> <br />
      <a :href="content.rat || content.rat_presencial" target="_blank">Link</a>
    </div>
    <div class="grid-12" v-else>
      <label>RAT</label> <br />
      <a :href="content.rat || content.rat_remoto" target="_blank">Link</a>
    </div>
    <div class="row grid-12 justify-center">
      <Button layout="green-go" :loader="ld" @click="orientado" v-if="modal.job.status === 'Com Doutor'">ESTOU
        ORIENTADO</Button>
      <Button layout="green-go" @click="modal.show = false" v-else>Fechar</Button>
    </div>
  </div>
  <div v-else class="loader-container column align-center justify-center">
    <Loader />
  </div>
</template>

<script>
import Loader from "@/components/Loader";
import { mapActions } from "vuex";
import Button from "@/components/Button";
export default {
  name: "Orientation",
  props: { modal: Object },
  components: { Button, Loader },
  data() {
    return {
      content: {},
      loader: true,
      ld: false
    };
  },
  methods: {
    ...mapActions("job", ["LOAD_ORIENTATION", "SET_ORIENTATION"]),
    ...mapActions("admin", ["ORIENTATION_SUPPORTER_GET"]),
    async load() {
      if (this.modal.job.id_orientacao)
        await this.LOAD_ORIENTATION(this.modal.job.id_orientacao).then(result => this.content = result);
      else
        await this.ORIENTATION_SUPPORTER_GET().then(({ data }) => this.content = data)
      this.loader = false;
    }, async orientado() {
      this.ld = true
      await this.SET_ORIENTATION(this.modal.job.id).then(() => (this.modal.cb(), this.modal.show = false))
      this.ld = false
    },
  },

  beforeMount() {
    this.load()
  }
};
</script>


<style lang="sass" scoped>
@use "@/assets/scss/vars.scss" as *
.orientation 
  padding-top: 25px
  color: $gray-6
  padding: 10px 30px
  padding-top: 25px
  padding-bottom: 25px
  a:hover
    color: $orange
    text-decoration: underline
  label
    color: $purple
    font-weight: bold

  @media (min-width: $small) 
    width: 600px
  .grid-12 
    margin-top: 35px
  button
    margin-top: 55px
  strong 
    font-weight: 500
    color: $gray-1
.loader-container 
  margin-top: 40px
  padding: 30px
</style>